const TWO_WEEKS_MS = 15 * 24 * 60 * 60 * 1000;
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

class FieldError extends Error {
	field: string;

	constructor(message: string, field: string) {
		super();
		this.name = 'FieldError';
		this.message = message;
		this.field = field;
	}
}

interface Image {
	id?: number;
	file?: File;
	url: string;
	position: number | null;
}

type Variant = 'neutral' | 'primary' | 'success' | 'warning' | 'danger';

interface Status {
	variant: Variant;
	icon: string;
	text: string;
}

export { FieldError, ONE_WEEK_MS, TWO_WEEKS_MS };
export type { Image, Variant, Status };
